class ConfiguratorFocus extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector("configurator-drawer");
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('button[type="submit"]');
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.nextSteps = {};
    this.getNextSteps();
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    const formData = new FormData(this.form);
    const focus = formData.get("focus");

    this.drawer.updateBundle("focus", focus);
    this.drawer.renderContents(this.nextSteps["thickness"]);
  }

  getNextSteps() {
    fetch("?sections=configurator-thickness")
      .then((response) => response.json())
      .then((response) => {
        this.nextSteps["thickness"] = response["configurator-thickness"];
        this.submitButton.removeAttribute('disabled');
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("configurator-focus", ConfiguratorFocus);
